import Cookies from 'js-cookie';

import { FACEBOOK_PIXEL_ID } from '@features/Analytics';
import { FACEBOOK_BACKEND_VARIANTS_MAP } from '@features/Analytics/constants';
import type { TpFacebookPostParametersV2 } from '@features/Analytics/types/facebook';
import { axiosMicroservice } from 'src/api/axios';
import { TEST_EVENT_CODE } from 'src/constants/api';
import { getDataFromSessionStorage } from 'src/utils';

export const postFacebookEventV2 = async ({
  externalId,
  eventId,
  eventName,
  fbp,
  options,
  customData,
}: TpFacebookPostParametersV2 & { fbp: string }) => {
  const fbc = Cookies.get('_fbc');

  const currentPixelIds = getDataFromSessionStorage({
    store: 'analyticsStore',
    key: 'fbPixelId',
  }) as unknown as string[];

  if (!currentPixelIds) {
    console.log('No pixel IDs found in session storage.');
    return [];
  }

  try {
    const requests = currentPixelIds.map(async (pixelId) => {
      const origin =
        FACEBOOK_BACKEND_VARIANTS_MAP.get(pixelId) ||
        FACEBOOK_BACKEND_VARIANTS_MAP.get(FACEBOOK_PIXEL_ID);

      const { data } = await axiosMicroservice.post('fb_event', {
        fbp,
        fbc,
        event_name: eventName,
        event_id: eventId,
        external_id: externalId,
        test_event_code: TEST_EVENT_CODE,
        origin,
        ...options,
        custom_data: { ...customData },
      });
      return data;
    });

    return await Promise.all(requests);
  } catch (error) {
    console.error('Error in sending Facebook events:', error);
    return [];
  }
};
